import type { JcCookieConsent } from '../../types/cookie-consent';
import {
  JC_CONSENT_COOKIE_NAME,
  JC_CONSENT_MAX_AGE_SECONDS,
} from './constants';
import { parseConsentFromCookieString } from './parse-consent-cookie';

export type SetConsentCookieOptions = {
  secure: boolean;
};

/**
 * Returns the `document.cookie` assignment value (name=value only is NOT enough — full attribute string).
 */
export function buildDocumentCookieAssignment(state: JcCookieConsent, options: SetConsentCookieOptions): string {
  const encoded = encodeURIComponent(JSON.stringify(state));
  let line = `${JC_CONSENT_COOKIE_NAME}=${encoded}; Path=/; Max-Age=${JC_CONSENT_MAX_AGE_SECONDS}; SameSite=Lax`;
  if (options.secure) {
    line += '; Secure';
  }
  return line;
}

/**
 * Persist consent in the browser (no-op if not in browser).
 */
export function setConsentCookieInBrowser(state: JcCookieConsent, options: SetConsentCookieOptions): void {
  if (typeof document === 'undefined') return;
  document.cookie = buildDocumentCookieAssignment(state, options);
}

/**
 * Read consent from document.cookie in the browser.
 */
export function readConsentFromBrowser(): JcCookieConsent | null {
  if (typeof document === 'undefined') return null;
  return parseConsentFromCookieString(document.cookie);
}
